export default __webpack_public_path__ + "static/test-generation-f3d30c7bd844b1460759ecb8cf23637f.gif";